import React from 'react';
import ReactDOMServer from 'react-dom/server';

const TicketEmailLayout = ({ details }) => {
  const { submittedBy, submittedOn, boothNumber, issue, actionTaken, notes, link } = details;

  const containerStyle = {
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    color: '#333333',
    backgroundColor: '#f9f9f9',
    padding: '30px',
    borderRadius: '8px',
    maxWidth: '600px',
    margin: '20px auto',
    border: '1px solid #dddddd',
  };

  const headingStyle = {
    fontSize: '20px',
    color: '#111111',
    marginBottom: '20px',
  };

  const hrStyle = {
    border: 'none',
    borderTop: '1px solid #eeeeee',
    margin: '25px 0',
  };

  const detailItemStyle = {
    fontSize: '15px',
    marginBottom: '12px',
    lineHeight: '1.5',
  };

  const labelStyle = {
    fontWeight: 'bold',
    color: '#555555',
  };

  const contentBlockStyle = {
    backgroundColor: '#ffffff',
    border: '1px solid #e9e9e9',
    padding: '15px',
    borderRadius: '4px',
    marginTop: '5px',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
  };

  const buttonStyle = {
    display: 'inline-block',
    padding: '12px 25px',
    margin: '15px 0',
    fontSize: '16px',
    color: '#ffffff',
    backgroundColor: '#00325a',
    textDecoration: 'none',
    borderRadius: '5px',
    textAlign: 'center',
  };

  const footerStyle = {
    fontSize: '12px',
    color: '#777777',
    textAlign: 'center',
    marginTop: '30px',
  };

  const content = (
    <div style={containerStyle}>
      <h2 style={headingStyle}>New ROTR Ticket Submission</h2>
      <div style={detailItemStyle}>
        <span style={labelStyle}>Submitted By:</span> {submittedBy}
      </div>
      <div style={detailItemStyle}>
        <span style={labelStyle}>Submitted On:</span> {submittedOn}
      </div>
      <div style={detailItemStyle}>
        <span style={labelStyle}>Booth Number:</span> {boothNumber}
      </div>
      <hr style={hrStyle} />
      <div style={detailItemStyle}>
        <span style={labelStyle}>Issue:</span>
        <div style={contentBlockStyle}>{issue}</div>
      </div>
      <div style={detailItemStyle}>
        <span style={labelStyle}>Action Taken:</span>
        <div style={contentBlockStyle}>{actionTaken}</div>
      </div>
      {notes && (
        <div style={detailItemStyle}>
          <span style={labelStyle}>Notes:</span>
          <div style={contentBlockStyle}>{notes}</div>
        </div>
      )}
      <hr style={hrStyle} />
      <p style={{ ...detailItemStyle, textAlign: 'center' }}>
        Click the button below to view all tickets for this booth.
      </p>
      <div style={{ textAlign: 'center' }}>
        <a href={link} style={buttonStyle}>
          View Tickets for Booth {boothNumber}
        </a>
      </div>
      <p style={footerStyle}>
        This is an automated message. Please do not reply directly to this email.
      </p>
    </div>
  );

  return ReactDOMServer.renderToStaticMarkup(content);
};

export default TicketEmailLayout;
